import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

import { Container, Header, Body } from './styles';

export default function FilterBox({ title, children, type }) {
  return (
    <Container>
      <Header>
        <Typography variant="h5">{title}</Typography>
      </Header>
      <Body type={type}>{children}</Body>
    </Container>
  );
}

FilterBox.defaultProps = {
  type: 'row',
};

FilterBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['row', 'column']),
};
